module.exports = __webpack_public_path__ + "img/_ic_star.89932965.svg";